// src/Component/ChatTeardownOnRouteChange.jsx
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Watches route changes and performs a soft teardown (disconnect clients,
 * don't kill sockets) whenever the user leaves a chat route.
 *
 * "Chat routes" = anything containing /all_chats, /chat, /chats, or /qchat.
 */
const CHAT_ROUTE_PATTERNS = ["/all_chats", "/chat", "/chats", "/qchat"];

function isChatRoute(pathname) {
  return CHAT_ROUTE_PATTERNS.some((p) => pathname.includes(p));
}

export default function ChatTeardownOnRouteChange() {
  const location = useLocation();
  const prevPath = useRef(location.pathname);

  useEffect(() => {
    const wasChatRoute = isChatRoute(prevPath.current);
    const isChatRouteNow = isChatRoute(location.pathname);

    if (wasChatRoute && !isChatRouteNow) {
      console.log(
        `[ChatTeardownOnRouteChange] leaving ${prevPath.current} → ${location.pathname}`,
      );

      // ⭐ Correct UMD call — same pattern as Settings.jsx uses for disableSound
      const softTeardown = window.MyPackage?.softTeardown;
      if (typeof softTeardown === "function") {
        Promise.resolve(softTeardown()).catch((err) =>
          console.warn(
            "[ChatTeardownOnRouteChange] softTeardown failed:",
            err,
          ),
        );
      } else {
        console.warn(
          "[ChatTeardownOnRouteChange] window.MyPackage.softTeardown not available",
        );
      }
    }

    prevPath.current = location.pathname;
  }, [location.pathname]);

  return null;
}